import { useState } from 'react'
import classnames from 'classnames'

import { getCreditCardShortCode } from 'shared/utils'
import { CardSection } from 'shared/components/CardSection'
import { CardSectionButton } from 'shared/components/CardSectionButton'
import Button from 'shared/components/Button'
import featureToggles from 'shared/featureToggles'
import AddCreditCardModal from 'shared/components/AddCreditCardModal'
import PixLogo from 'shared/assets/PixPayment.png'
import { PIX_PAYMENT_METHOD } from 'booking/constants'
import styles from './styles.module.scss'

const getCardDisplayName = card => `${getCreditCardShortCode(card?.cardType)} **** ${card?.lastFour || card?.maskedPan}`

const PaymentMethodSection = ({
    paymentMethods,
    setPaymentMethod,
    selectedPaymentMethod,
    showPixPaymentMethod,
    guestUserFlow,
    removeGuestUserCard,
}) => {
    const [showAddCardModal, setShowAddCardModal] = useState(false)

    const pixMethodSelected =
        !paymentMethods || paymentMethods.length < 1 || selectedPaymentMethod?.id === PIX_PAYMENT_METHOD

    const title = featureToggles.supportsDebitCard
        ? 'subscription.purchase.label.title.withdebit'
        : 'subscription.purchase.label.title'

    const sectionTitle = guestUserFlow ? (
        <h3 className="font-weight-bold text-uppercase mb-4">
            <T>subscription.purchase.label.payment.method</T>
        </h3>
    ) : (
        <h5 className="mb-4">
            <T>subscription.purchase.label.payment.method</T>
        </h5>
    )

    const showRemoveCardButton = guestUserFlow && paymentMethods?.length > 0

    const RemoveCardButton = () => (
        <Button
            size="small"
            type="button"
            btnStyle="link"
            iconLeft="minus-round"
            onClick={removeGuestUserCard}
            className="mb-3">
            <T>guest.booking.review.pay.remove.credit.card.label</T>
        </Button>
    )
    const AddCardButton = () => (
        <Button
            size="small"
            type="button"
            btnStyle="link"
            iconLeft="plus-round"
            onClick={() => setShowAddCardModal(true)}
            className="mb-3">
            <T>dashboard.label.add.credit.card</T>
        </Button>
    )

    React.useEffect(() => {
        guestUserFlow && paymentMethods && setPaymentMethod(paymentMethods[0])
    }, [paymentMethods])

    return (
        <>
            {showAddCardModal && <AddCreditCardModal onClose={() => setShowAddCardModal(false)} />}
            <div className="mt-5">
                {sectionTitle}
                <CardSection
                    activeSelected={
                        paymentMethods && !!selectedPaymentMethod && selectedPaymentMethod.id !== PIX_PAYMENT_METHOD
                    }
                    notActive
                    className="px-3 py-3 mt-6 mb-6">
                    <div className="d-sm-flex justify-content-between">
                        <div className={classnames('d-flex', 'flex-column', styles.paymentSelectionTitle)}>
                            <span className="font-weight-bold">
                                <T>{title}</T>
                            </span>
                        </div>
                        <div className="d-flex flex-wrap flex-row">
                            {paymentMethods &&
                                paymentMethods.map((p, i) => (
                                    <CardSectionButton
                                        key={i}
                                        onClick={() => setPaymentMethod(p)}
                                        value={getCardDisplayName(p)}
                                        description={p?.nickName}
                                        isSelected={p?.id === selectedPaymentMethod?.id}
                                        className={styles.paymentMethodBtn}
                                    />
                                ))}
                        </div>
                    </div>
                </CardSection>
                {showPixPaymentMethod && (
                    <CardSection activeSelected={pixMethodSelected} notActive className="px-3 py-3 mt-6 mb-6">
                        <div
                            onClick={() => setPaymentMethod({ id: PIX_PAYMENT_METHOD })}
                            className="d-flex justify-content-between">
                            <span className="font-weight-bold">
                                <T>subscription.purchase.pix.label</T>
                            </span>
                            <CardSectionButton
                                onClick={() => setPaymentMethod({ id: PIX_PAYMENT_METHOD })}
                                isSelected={pixMethodSelected}
                                className={classnames(
                                    styles.pixPaymentMethodBtn,
                                    pixMethodSelected && styles.pixPaymentMethodBtnActive
                                )}>
                                <img src={PixLogo} alt={<T>subscription.purchase.pix.label</T>} />
                            </CardSectionButton>
                        </div>
                    </CardSection>
                )}
                {showRemoveCardButton ? <RemoveCardButton /> : <AddCardButton />}
            </div>
        </>
    )
}

export default PaymentMethodSection
